import React from 'react'

import Table1 from './Table1'
import PurchasingDetails from './PurchasingDetails';

function Tab3({ formData, onFieldChange, extraData }) {
    console.log(extraData, "extraData-check");

    return (

        <div className="px-4 py-4" style={{ background: 'white' }}>
            <PurchasingDetails
                formData={formData}
                onFieldChange={onFieldChange}
                extraData={extraData}
            />

            <Table1
                title="Supplier Details"
                setselected_item_data={[]}
                createNewRow={[]}
                columns={extraData.ItemColumnsTab3Table1}
                rows={[]}
                setRows={() => { }}
                list_data={() => { }}
                po_status={""}
            /> 




        </div>

    )
}

export default Tab3
